import HeroAdvisory from "components/PropertyAdvisory/HeroAdvisory";
import ListAdvisory from "components/PropertyAdvisory/ListAdvisory";
import MissionAdvisory from "components/PropertyAdvisory/MissionAdvisory";
import QuoteAdvisory from "components/PropertyAdvisory/QuoteAdvisory";
import PriceSection from "components/Service/PriceSection";
import React, { useEffect } from "react";
import BookSection from "components/Events/BookSection";
import { useLocation } from "react-router-dom";

const PropertyAdvisory = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");

      setTimeout(() => {
        const element = document.getElementById(id);

        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 100);
    }
  }, [location]);
  return (
    <div>
      {/* <HeroAdvisory /> */}
      <MissionAdvisory />

      <QuoteAdvisory />
      <div id="propertyadvisory">
        <ListAdvisory />
      </div>
      {/* <PriceSection /> */}
      <BookSection />
    </div>
  );
};

export default PropertyAdvisory;
